export default __webpack_public_path__ + "static/media/sweaterbg.dccf4fc9.jpg";